import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { UserFriendIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/dashboard/conversion-analytics')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="dashboard.conversion.pageTitle.conversionMetrics" icon={UserFriendIcon} />,
      title: <Translation id="dashboard.conversion.pageTitle.conversionMetrics" />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
